import { createApp } from 'vue'
import App from '@/App.vue'
export const VueApp = createApp(App)
